import React, { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import styled, { keyframes } from "styled-components"
import { translate } from "react-i18next"
import { lighten } from "polished"
import tada from "react-animations/lib/tada"
import LoginViaIdServer from "./LoginViaIdServer"

const Wrapper = styled.div`
  text-align: center;
  padding: 10px 0 20px 0;
  height: 300px;
  position: relative;
`

const animation = keyframes`${tada}`

const Icon = styled.i`
  animation: 1s ${animation};
  color: ${prop => lighten(0.3, prop.color)};
  font-size: 4em;
`

const IconContainer = styled.div`
  text-align: center;
  margin: 20px 0;
`

const MessageContainer = styled.div`
  text-align: center;
`

const Header = styled.h3`
  color: ${prop => prop.color};
`

/** The loading spinner to display whilst a particular filter field is having its values loaded */
function LoginViaTT({ t, theme }) {
  return (
    <Wrapper>
      <Fragment>
        <IconContainer className="col-sm-12">
          <Icon
            color={theme.primaryColor}
            className="fa fa-exclamation-triangle"
            aria-hidden="true"
          />
        </IconContainer>
        <MessageContainer className="col-sm-12">
          <Header color={theme.primaryColor}>{t("Common.Login.Issue")}</Header>
          <p>{t("Common.Login.Message")}</p>
          <LoginViaIdServer />
        </MessageContainer>
      </Fragment>
    </Wrapper>
  )
}

LoginViaTT.propTypes = {
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(LoginViaTT)



// WEBPACK FOOTER //
// ./src/components/auth/LoginViaTT.jsx